import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDrawerMode, MatSidenav } from '@angular/material/sidenav';

@Component({
  selector: 'app-operator-layout',
  templateUrl: './operator-layout.component.html',
  styleUrls: ['./operator-layout.component.scss']
})
export class OperatorLayoutComponent implements OnInit {

  public drawerMode: MatDrawerMode;

  constructor(
    private observer: BreakpointObserver
  ) { }

  ngOnInit(): void {
      
  }

  ngAfterViewInit() {
    this.observer.observe(['(max-width: 800px)']).subscribe((res) => {
      if (res.matches) {
        this.drawerMode = 'over';
      } else {
        this.drawerMode = 'side';
      }
    });
  }

}
